module.exports = __webpack_public_path__ + "img/img60.058724c8.svg";